import { useState } from 'react'
import type { UsualSuspect } from '../../hooks/useUsualSuspects'

type Props = {
  suspects: UsualSuspect[]
  onAdd:    (suspect: UsualSuspect) => Promise<void> | void
}

export function UsualSuspects({ suspects, onAdd }: Props) {
  const [adding, setAdding] = useState<Set<string>>(new Set())
  const [added,  setAdded]  = useState<Set<string>>(new Set())

  if (suspects.length === 0) return null

  async function handleAdd(s: UsualSuspect) {
    if (added.has(s.itemId) || adding.has(s.itemId)) return
    setAdding(prev => new Set(prev).add(s.itemId))
    try {
      await onAdd(s)
      setAdded(prev => new Set(prev).add(s.itemId))
    } finally {
      setAdding(prev => {
        const next = new Set(prev)
        next.delete(s.itemId)
        return next
      })
    }
  }

  return (
    <section>
      <div className="mb-[10px] flex items-baseline gap-[10px]">
        <h2 className="font-serif text-[18px] font-normal tracking-[-0.01em] text-ink">
          Usual <em className="italic">suspects</em>
        </h2>
        <div className="h-px flex-1 bg-border-sand" />
        <span className="text-[10px] font-medium uppercase tracking-[0.1em] text-ink-muted">
          Tap to add
        </span>
      </div>

      <div className="flex flex-wrap gap-[6px]">
        {suspects.map(s => {
          const isAdded  = added.has(s.itemId)
          const isAdding = adding.has(s.itemId)
          return (
            <button
              key={s.itemId}
              onClick={() => handleAdd(s)}
              disabled={isAdded || isAdding}
              className={
                isAdded
                  ? 'rounded-[10px] border border-[#BFD4C0] bg-[#E0EBE2] px-3 py-[7px] text-[12px] font-medium text-forest transition-colors'
                  : 'rounded-[10px] border border-border-sand bg-paper px-3 py-[7px] text-[12px] font-medium text-ink transition-colors disabled:opacity-60'
              }
            >
              {isAdded ? '✓ ' : isAdding ? '… ' : '+ '}
              {s.name}
            </button>
          )
        })}
      </div>
    </section>
  )
}
